import React from 'react';
import PropTypes from 'prop-types';
import Theme from "./Theme.js";
/**
 * React class that renders a Slider 
 * @property {string} className css class to be applied to this component
 * @property {string} variant Theme variant name to be added to the component
 * @property {function} onChange function to be called when the button is clicked
 * @property {any} eventData will be passed through as the data key to the onClick function
 * @property {number | string} min the minimum value of the slider range 
 * @property {number | string} max the maximum value of the slider range 
 * @property {number | string} value the current value of the slider 
 * */
import { jsx as _jsx } from "react/jsx-runtime";
class Slider extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    onChange: PropTypes.func,
    eventData: PropTypes.any,
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
  static defaultProps = {
    className: null,
    variant: null,
    onChange: null,
    eventData: null,
    min: 0,
    max: 100,
    value: undefined
  };

  /** 
   * (Internal) onClick of the element just adds the eventData prop to the event, and then calls the onClick prop
   */
  onChange = e => {
    const {
      onChange,
      eventData
    } = this.props;
    e.preventDefault();
    if (typeof onChange === 'function') {
      onChange({
        value: e.target.value,
        data: eventData
      });
    }
  };
  render() {
    const theme = this.context;
    const {
      className,
      value,
      variant,
      min,
      max,
      eventData,
      layoutOptions,
      ...rest
    } = theme.props('Slider', this.props); // eslint-disable-line
    const cn = theme.classes('Slider', 'slider', variant, className);
    return /*#__PURE__*/_jsx("input", {
      type: "range",
      min: min,
      max: max,
      className: cn,
      ...rest,
      value: value,
      onChange: this.onChange
    });
  }
}
export default Slider;